import React, { Dispatch, Fragment, SetStateAction, useCallback, useState } from 'react';

import PageContent from 'components/PageContent';
import { IFlightTicketProposal } from 'entities/Flights/sdk';

import AttendeesSection from '../AttendeesSection';
import FlightInformationSection from '../FlightInformationSection';
import OfferDetailsSection from '../OfferDetailsSection';
import TotalSection from '../TotalSection';
import { FlightOfferViewEnum } from '../constants';
import { KeyedMutator } from 'swr';
import { FlightTicketProposalStatusEnum } from 'utils/constants';

interface IDetailsViewProps {
  flightTicketProposal: IFlightTicketProposal;
  setView: Dispatch<SetStateAction<FlightOfferViewEnum>>;
  currency: string | null;
  setCurrency: Dispatch<SetStateAction<string | null>>;
  flightTicketProposalMutate: KeyedMutator<IFlightTicketProposal>;
}

const DetailsView: React.FC<IDetailsViewProps> = ({
  flightTicketProposal,
  setView,
  currency,
  setCurrency,
  flightTicketProposalMutate,
}) => {
  const [isPersonalInfoAgreed, setPersonalInfoAgreed] = useState(false);
  const [isFlightInfoAgreed, setFlightInfoAgreed] = useState(false);

  const hasAlreadyAgreed = flightTicketProposal.status === FlightTicketProposalStatusEnum.NOT_PAID;
  const isOfferExpired = new Date(flightTicketProposal.expiration_datetime) < new Date();

  const handleConfirmAndProceedClick = useCallback(() => {
    if (isOfferExpired) {
      return;
    }

    setView(FlightOfferViewEnum.PAYMENT);
  }, [setView, isOfferExpired]);

  return (
    <Fragment>
      <PageContent>
        <div className='flex flex-col gap-[80px] max-md:gap-[60px]'>
          <AttendeesSection
            people={flightTicketProposal.travel_request_people}
            isPersonalInfoAgreed={isPersonalInfoAgreed}
            setPersonalInfoAgreed={setPersonalInfoAgreed}
            hasAlreadyAgreed={hasAlreadyAgreed}
          />
          <FlightInformationSection
            pdfUrl={flightTicketProposal.flight_ticket_proposal_pdf.url}
            hasAlreadyAgreed={hasAlreadyAgreed}
            isFlightInfoAgreed={isFlightInfoAgreed}
            setFlightInfoAgreed={setFlightInfoAgreed}
          />
          <OfferDetailsSection expirationDate={flightTicketProposal.expiration_datetime} />
        </div>
      </PageContent>
      <TotalSection
        view={FlightOfferViewEnum.DETAILS}
        isConfirmDisabled={(!hasAlreadyAgreed && (!isFlightInfoAgreed || !isPersonalInfoAgreed)) || isOfferExpired}
        flightTicketProposal={flightTicketProposal}
        handleConfirmClick={handleConfirmAndProceedClick}
        handleCancelClick={() => {}}
        currency={currency}
        setCurrency={setCurrency}
        flightTicketProposalMutate={flightTicketProposalMutate}
      />
    </Fragment>
  );
};

export default DetailsView;
